import useIsPrismFormEditorRequested from '../useIsPrismFormEditorRequested';

const useIsPrismFormEditorEnabled = (isTemplateSavedInPrism = false, prismBlockReason = null) => {
  const isPrismRequested = useIsPrismFormEditorRequested(isTemplateSavedInPrism);

  return !prismBlockReason && isPrismRequested;
};

export default useIsPrismFormEditorEnabled;
